export enum MessageEnum {
  HUMAN = "human",
  AI = "ai",
}
